import { useEffect, useState, useCallback } from "react";
import { supabase } from "@/lib/supabase";

export interface EquipoDB {
  id: number;
  nombre: string;
  cargo: string;
  direccion: string;
  email: string;
  telefono: string;
  foto: string;
  orden: number;
  created_at: string;
}

export function useEquipo() {
  const [data, setData] = useState<EquipoDB[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  const fetchData = useCallback(async () => {
    setLoading(true);
    setError(null);
    try {
      const { data: result, error: err } = await supabase
        .from("equipo")
        .select("*")
        .order("orden", { ascending: true });
      if (err) throw err;
      setData((result as EquipoDB[]) ?? []);
    } catch {
      setError("Error cargando equipo");
      setData([]);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    fetchData();
  }, [fetchData]);

  return { data, loading, error, refetch: fetchData };
}